import React from 'react'
import styled, { keyframes } from 'styled-components'
import Modal from 'react-modal'
import moment from 'moment'
import { notify } from 'react-notify-toast'
import { isMobile } from 'react-device-detect'

import chatButtonIcon from '../../../assets/mainScreen/chat.png'
import SendButtonicon from '../../../assets/mainScreen/sendButtonicon.png'
import upArrow from '../../../assets/mainScreen/upArrow.png'
import ReportMessagebackground from '../../../assets/mainScreen/reportMessageBackground.png'
import Reporticon from '../../../assets/mainScreen/reportIcon.png'
import Chaticon from '../../../assets/mainScreen/chatIcon.png'
import { CloseButton } from './DropdownMenu.jsx'
import { fontSizeResponsive, mediaQ } from '../../theme/mixins'
import ArrowRight from '../../../assets/mainScreen/arrowRight.png'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import Loader from 'react-loader-spinner'
// import {
//   AcceptDeleteButton,
//   CancelDeleteButton,
// } from './subDropdown/DeleteAccountDropdownModal.jsx'

// import { deleteUser } from '../../../../Api/backendApi'

const DropdownModalContainer = styled.div`
  height: -webkit-fill-available;

  /* padding: 10px 20px; */
`
const DropdownModalRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const DropdownModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #fe0d9f;
  padding: 20px 0;

  ${fontSizeResponsive(40)};

  ${mediaQ('mobileAll', 'font-size:16px;')}
`
const DropdownModalRowText = styled.span`
  font-family: 'Open Sans';
  font-stretch: condensed;
  ${fontSizeResponsive(20)};
  margin: 8px 0;

  ${mediaQ('mobileAll', 'margin: 1px 0;')}

  &:before {
    content: '|';
    ${fontSizeResponsive(24)};
  }

  span {
    font-weight: bold;
    margin-left: 5px;
    ${fontSizeResponsive(22)};
  }
`

const DropdownModalSubHeader = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #212121;
  ${fontSizeResponsive(24)};
  margin-bottom: 20px;

  span {
    font-weight: bold;
    ${fontSizeResponsive(28)};
    color: rgba(158, 13, 254, 1);
    margin-left: 5px;
  }
`

const DropdownModalSecondHaeder = styled.div`
  width: 50%;
  margin-left: 35%;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  ${fontSizeResponsive(26)};

  ${mediaQ('mobileAll', 'width:100%; margin-left: 0;text-align: center;')}
`
const DiagnosticDataContainer = styled.div`
  margin: 15px 0px;
  background-color: rgba(0, 0, 0, 0.036);
  border: 1px solid rgba(0, 0, 0, 0.036);
  width: 50%;
  align-self: center;
  border-radius: 7px;
  padding: 5px 10px;
  box-shadow: 0 2.5px 1.4px -26px rgba(0, 0, 0, 0.011),
    0 6.1px 3.3px -26px rgba(0, 0, 0, 0.016),
    0 11.4px 6.3px -26px rgba(0, 0, 0, 0.02),
    0 20.3px 11.2px -26px rgba(0, 0, 0, 0.024),
    0 38px 20.9px -26px rgba(0, 0, 0, 0.029),
    0 91px 50px -26px rgba(0, 0, 0, 0.04);

  ${mediaQ('mobileAll', 'width:100%;')}
`

const DropdownModalCopyButton = styled.button`
  width: 45%;
  align-self: center;
  padding: 10px 30px;
  border: none;
  outline: none;
  background: linear-gradient(
    90deg,
    rgba(254, 13, 160, 1) 0%,
    rgba(250, 174, 1, 1) 100%
  );
  font-family: 'Asap Condensed';
  text-align: center;
  font-weight: 600;
  color: white;
  transition: ease-in-out 0.35s all;
  ${fontSizeResponsive(26)};

  ${mediaQ('mobileAll', 'width:80%;')}

  &:hover {
    transform: scale(1.025);
    border: none;
  }
`

const DropdownModalButtonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`

const AcceptDeleteButton = styled.button`
  background-color: rgb(187, 33, 36);
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  color: white;
  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 2.8px 2.2px,
    rgba(0, 0, 0, 0.027) 0px 6.7px 5.3px, rgba(0, 0, 0, 0.035) 0px 12.5px 10px,
    rgba(0, 0, 0, 0.043) 0px 22.3px 17.9px,
    rgba(0, 0, 0, 0.05) 0px 41.8px 33.4px, rgba(0, 0, 0, 0.07) 0px 100px 80px;
  margin: 10px 15px;
  cursor: pointer;
`
const CancelDeleteButton = styled.button`
  background-color: rgba(0, 0, 0, 0.05);
  opacity: 0.6;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  color: rgba(0, 0, 0, 0.8);
  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.02),
    0 6.7px 5.3px rgba(0, 0, 0, 0.028), 0 12.5px 10px rgba(0, 0, 0, 0.035),
    0 22.3px 17.9px rgba(0, 0, 0, 0.042), 0 41.8px 33.4px rgba(0, 0, 0, 0.05),
    0 100px 80px rgba(0, 0, 0, 0.07);
  margin: 10px 15px;
  cursor: pointer;
`

const ChatModalContent = styled.div`
  height: calc(50vh - 50px);
  overflow: auto;
  scroll-snap-type: y proximity;
  padding: 10px 10px;
  box-sizing: border-box;
  margin-top: 0px;

  ${mediaQ('mobileAll', 'height:60vh;')}
`
const ChatModalMessageRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px;

  border-radius: 4px;

  margin: 15px 5px 5px 5px;
  /* height: 20%; */
`
const ChatModalAuthor = styled.span`
  margin-right: 15px;
  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  color: #fe0d9f;
  ${fontSizeResponsive(18)}

  ${mediaQ('mobileAll', 'font-size:16px;')}
`
const ChatModalMessage = styled.span`
  color: ${(props) => (props.specialMessage ? 'white' : '#3a3a3a')};
  font-family: 'Open Sans', sans-serif;
  font-weight: ${(props) => (props.specialMessage ? '400' : '600')};
  border-radius: 4px;
  ${fontSizeResponsive(14)}
  margin-top:8px;
  padding: ${(props) => (props.specialMessage ? '5px' : 'unset')};
  background-color: ${(props) => (props.specialMessage ? '#C6C6C6' : 'unset')};
  line-height: 1.15rem;
  text-align: ${(props) => (props.specialMessage ? 'center' : 'unset')};

  ${mediaQ('mobileAll', 'font-size:12px; margin-top: 4px;')}
`
const ChatModalMessageTimeAndnameContainer = styled.div`
  display: flex;
  align-items: baseline;
`
const ChatModalMessageTime = styled.span`
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(12)}
  color: #6C6C6C;
  font-weight: 300;
  ${mediaQ('mobileAll', 'font-size:11px;')}
`
const ActionRow = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 10px 20px;
  box-sizing: border-box;
  position: relative;

  position: relative;
  top: 0%;
  padding-top: 15%;
`
const Input = styled.input`
  width: inherit;
  border: none;

  margin-top: 10px;
  padding: 5px 50px 15px 0;
  color: #3a3a3a;
  font-family: 'Asap Condensed';
  font-weight: 600;

  border-bottom: rgba(254, 13, 159, 0.2) 2px solid;
  /* transform: rotate(0deg) translateY(0px); */
  transition: 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95) all;

  &:focus {
    border-bottom: 2px solid #9e0dfe;
  }
`
const unanimateButton = keyframes`
from{transform: translateY(-5px) rotate(-90deg) }
to{transform: rotate(0deg) translateY(0px) }
`
const animateButton = keyframes`
from{transform: rotate(0deg) translateY(0px)}
to{transform: translateY(-5px) rotate(-90deg) }
  /* 0% {transform: rotate(0deg) translateY(0px) }
  50% { transform: rotate(-90deg) }
  100% {transform: translateY(-5px) rotate(-90deg) scale(1.15)} */

`
const SendButton = styled.div`
  width: 50px;
  height: 50px;
  position: absolute;
  right: 20px;
  bottom: 20px;
  opacity: ${(props) => (props.isSending ? '0.5' : '1')};

  animation: ${unanimateButton};
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
  animation-duration: 0.5s;

  &:hover {
    animation: ${animateButton};
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
    animation-duration: 0.5s;
    /* animation-direction: alternate; */
  }
`

const SendButtonImage = styled.div`
  background: url(${SendButtonicon});
  background-size: contain;
  background-repeat: no-repeat;
  width: 50px;
  height: 50px;
  position: relative;
  margin-left: auto;
  cursor: pointer;

  &:hover {
  }

  /* &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    background: linear-gradient(
      135deg,
      rgba(254, 13, 160, 1) 0%,
      rgba(250, 174, 1, 1) 100%
    );
    border-radius: 50%;
  } */
`

const ScrollContainer = styled.div`
  position: relative;

  &:hover {
    cursor: ${(props) => (props.specialMessage ? 'unset' : 'pointer')};
    background: ${(props) =>
      props.specialMessage ? 'unset' : `url(${ReportMessagebackground})`};
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 4px;

    &:after {
      content: '';
      position: absolute;
      width: 10%;
      height: -webkit-fill-available;
      top: -45%;
      right: 10px;
      background: ${(props) =>
        props.specialMessage ? 'unset' : `url(${Reporticon})`};
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  /* overflow: auto;
  display: flex;
  flex-direction: column-reverse; */
`

const ChatModalTopBar = styled.div`
  display: flex;
  justify-content: center;
  justify-content: space-between;
  background-image: linear-gradient(94deg, #fe0da0, #faae01);
  padding: 10px;
`

const ChatModalTopBarUserName = styled.div`
  /* margin-left: calc(50% - 30px); */
  display: flex;
  align-items: center;
  margin-right: 40px;
  font-family: 'Asap Condensed';
  font-weight: 600;
  font-stretch: condensed;
  color: white;
  ${fontSizeResponsive(20)}
  padding: 0 10px;

  ${mediaQ('mobileAll', 'font-size:22px;')}
`
const ChatModalIconContainer = styled.div`
  display: flex;
  align-items: center;
`
const ChatModalIconContainerText = styled.span`
  font-family: 'Asap Condensed';
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  color: white;
  ${fontSizeResponsive(18)}

  ${mediaQ('mobileAll', 'font-size:20px;')}
`
const ChatModalIconContainerIcon = styled.div`
  background: url(${Chaticon});
  background-size: contain;
  background-repeat: no-repeat;
  width: 30px;
  height: 30px;
  margin-left: 5px;
`

const ReportButton = styled.button`
  margin-left: auto;
  font-family: 'Asap Condensed';
  ${fontSizeResponsive(16)}
  color: #6C6C6C;
  font-weight: 300;
  border: none;
  border-radius: 4px;
  box-shadow: 0 1px 19.8px -57px rgba(0, 0, 0, 0.015),
    0 2.1px 34.5px -57px rgba(0, 0, 0, 0.021),
    0 3.5px 44.8px -57px rgba(0, 0, 0, 0.024),
    0 5.2px 51.4px -57px rgba(0, 0, 0, 0.027),
    0 7.5px 54.9px -57px rgba(0, 0, 0, 0.031),
    0 11.1px 56px -57px rgba(0, 0, 0, 0.037),
    0 17px 56px -57px rgba(0, 0, 0, 0.044),
    0 28.6px 57.5px -57px rgba(0, 0, 0, 0.055),
    0 61px 76px -57px rgba(0, 0, 0, 0.07);
`

const ActionRowInstruction = styled.div`
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  ${fontSizeResponsive(16)}
  color: rgba(	108,	108	,108,0.6);
  display: flex;
  align-items: flex-end;
  font-weight: 600;

  ${mediaQ('mobileAll', 'font-size:14px;')}
`

const InsertChatNameContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgb(254, 13, 160);
  background: linear-gradient(
    135deg,
    rgba(254, 13, 160, 0.8463760504201681) 0%,
    rgba(250, 174, 1, 1) 100%
  );
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const InsertChatNameContainerInput = styled.input`
  border: none;
  border-bottom: 2px solid white;
  margin-top: 10px;
  padding: 5px 10px 15px 10px;
  font-family: 'Asap Condensed';
  background-color: transparent;
  width: 85%;
  color: white;
  font-weight: 200;
  ${fontSizeResponsive(19)}

  ${mediaQ('mobileAll', 'font-size: 22px;')}

  &::placeholder {
    color: white;
    font-weight: 200;
  }
`
const InsertChatNameContainerButton = styled.button`
  border: none;
  margin-top: 20px;
  padding: 5px 0 15px 0;
  font-family: 'Asap Condensed';
  color: white;
  background-color: transparent;
  text-transform: uppercase;
  letter-spacing: 3px;
  position: relative;
  ${fontSizeResponsive(22)}
  font-weight: 600;

  &:after {
    content: '';
    position: absolute;
    right: -35px;
    top: 11px;
    background: url(${ArrowRight});
    background-size: contain;
    background-repeat: no-repeat;
    width: 13px;
    height: 13px;

    ${mediaQ('mobileAll', 'width: 10px; height: 10px; top: 7px;')}
  }
`

const ReportInformationRow = styled.div`
  width: 100%;
  border-bottom: rgba(32, 28, 31, 0.1) 2px solid;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
  font-family: 'Asap Condensed';
  color: #6c6c6c;
  font-weight: 600;
  ${fontSizeResponsive(14)}
  margin-bottom: 20px;
  position: absolute;
  top: 0;
  left: 0;
  box-sizing: border-box;

  ${mediaQ('mobileAll', 'font-size:12px;')}
`

const ReportInformationBox = styled.div`
  background-color: #c5ff00;
  font-family: 'Asap';
  ${fontSizeResponsive(20)}
  font-weight: normal;
  font-stretch: condensed;
  font-style: normal;
  line-height: 3.5;
  letter-spacing: 1.8px;
  padding: 0 15px;
  text-align: center;
  color: #212121;
  ${mediaQ('mobileAll', 'font-size:18px;')}
`

const SendingMessageLoader = styled(Loader)`
  position: absolute;
  width: 85%;
  display: flex;
  justify-content: center;
`

const LoadingMessagesLoader = styled(Loader)`
  position: absolute;
  z-index: 4;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
`

const ChatModal = ({
  closeChatModal,
  chatModalIsOpen,
  messages,
  setMessage,
  chatMessageToSend,
  addMessage,
  reportMessage,
  editUserChatName,
  userChatName,
  isChatNameSet,
  handleChatJoinButton,
  addmessageOnEnter,
  isReportSuccess,
  handleCloseReportScreen,
  closeReportConfirmationModal,
  isReportConfirmationModalOpen,
  handleMobileReportMessage,
  user,
  isDemoAccount,
  sendingMessage,
  loadingMessages,
}) => {
  const customStyles = {
    overlay: { zIndex: 1000, backgroundColor: `rgba(0, 0, 0, 0)` },
    content: {
      position: 'relative',
      right: `unset`,
      bottom: `unset`,
      width: `${isMobile ? '100%' : '20%'}`,
      height: `${isMobile ? '100%' : '65%'}`,
      top: `${isMobile ? '0' : '32%'}`,
      left: `${isMobile ? '0' : '79%'}`,
      // overflow: 'hidden',
      padding: 0,
      boxShadow: `
        0 1.7px 22.2px -16px rgba(0, 0, 0, 0.015),
        0 3.5px 38.6px -16px rgba(0, 0, 0, 0.021),
        0 5.8px 50.2px -16px rgba(0, 0, 0, 0.024),
        0 8.6px 57.5px -16px rgba(0, 0, 0, 0.027),
        0 12.6px 61.4px -16px rgba(0, 0, 0, 0.031),
        0 18.6px 62.7px -16px rgba(0, 0, 0, 0.037),
        0 28.5px 62.7px -16px rgba(0, 0, 0, 0.044),
        0 47.8px 64.3px -16px rgba(0, 0, 0, 0.055),
        0 102px 85px -16px rgba(0, 0, 0, 0.07)`,
      borderRadius: '6px',
      border: 'none',
      // transform: `${isMobile ? 'translate(0%, 0%);' : 'translate(-50%, -65%)'}`,
    },
  }

  const smallModalStyle = {
    overlay: {
      zIndex: 1000,
      backgroundColor: `rgba(0, 0, 0, 0.5)`,
    },
    content: {
      right: `unset`,
      bottom: `unset`,
      top: `20%`,
      left: `10%`,
      width: ' 70%',
    },
  }
  const timestampToDate = (timestamp) => {
    let unix_timestamp = timestamp
    const timedifference = Math.round(new Date().getTimezoneOffset() / 60)
    const date = new Date(unix_timestamp * 1000)
    const hours = date.getHours()
    const minutes = '0' + date.getMinutes()

    const formattedTime = hours + ':' + minutes.substr(-2)

    return formattedTime
  }

  return (
    <Modal
      isOpen={chatModalIsOpen}
      // onAfterOpen={afterOpenModal}
      onRequestClose={closeChatModal}
      style={customStyles}
      // afterOpenModal={afterOpenModal}
    >
      {loadingMessages && (
        <LoadingMessagesLoader
          type="TailSpin"
          color="#fe0d9f"
          height={isMobile ? 45 : 100}
          width={isMobile ? 45 : 100}
        >
          ladowanie wiadomosci
        </LoadingMessagesLoader>
      )}
      <Modal
        isOpen={isReportConfirmationModalOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeReportConfirmationModal}
        style={smallModalStyle}
        // afterOpenModal={afterOpenModal}
      >
        <DropdownModalContainer>
          <DropdownModalHeader>
            Czy na pewno chcesz zgłosić wiadomość?
          </DropdownModalHeader>
          <DropdownModalRow>
            <CancelDeleteButton onClick={closeReportConfirmationModal}>
              Anuluj
            </CancelDeleteButton>
            <AcceptDeleteButton onClick={handleMobileReportMessage}>
              Tak
            </AcceptDeleteButton>
          </DropdownModalRow>
        </DropdownModalContainer>
      </Modal>
      {!isChatNameSet ? (
        <InsertChatNameContainer>
          <InsertChatNameContainerInput
            onChange={(e) => editUserChatName(e)}
            placeholder={userChatName == '' ? 'Wpisz imię' : userChatName}
          ></InsertChatNameContainerInput>
          <InsertChatNameContainerButton onClick={handleChatJoinButton}>
            Dołącz
          </InsertChatNameContainerButton>
        </InsertChatNameContainer>
      ) : null}

      {isReportSuccess ? (
        <InsertChatNameContainer>
          {/* <InsertChatNameContainerInput
            onChange={(e) => editUserChatName(e)}
            placeholder={userChatName == '' ? 'Wpisz imię' : userChatName}
          ></InsertChatNameContainerInput> */}
          <ReportInformationBox>Zgłoszono nadużycie</ReportInformationBox>
          <InsertChatNameContainerButton onClick={handleCloseReportScreen}>
            WRÓĆ
          </InsertChatNameContainerButton>
        </InsertChatNameContainer>
      ) : null}

      <DropdownModalContainer className="DropdownModal">
        <ChatModalTopBar>
          <ChatModalIconContainer>
            <ChatModalIconContainerText>ChatBox</ChatModalIconContainerText>
            <ChatModalIconContainerIcon></ChatModalIconContainerIcon>
          </ChatModalIconContainer>
          <ChatModalTopBarUserName>
            {userChatName && userChatName}
          </ChatModalTopBarUserName>
          <CloseButton
            onClick={closeChatModal}
            whiteCloseIcon
            position="relative"
            top="5px !important"
            right="5px"
            modal
            // marginLeft="auto"
          />
        </ChatModalTopBar>
        {/* <DropdownModalHeader>Chat</DropdownModalHeader> */}
        <ChatModalContent id="scroll-container">
          {messages ? (
            messages.map((message, i) =>
              message.message.length > 0 ? (
                <ScrollContainer
                  className="messages__single-message"
                  id={i}
                  specialMessage={message.author_id == -1}
                  onClick={() =>
                    user && user.is_banned_on_chat
                      ? null
                      : reportMessage(message)
                  }
                >
                  <ChatModalMessageRow>
                    {message.author_id == -1 ? null : (
                      <ChatModalMessageTimeAndnameContainer
                      // onMouseEnter={(e) => addbackground(e)}
                      // onMouseLeave={(e) => removebackground(e)}
                      >
                        <ChatModalAuthor>{message.author_name}</ChatModalAuthor>
                        <ChatModalMessageTime>
                          {timestampToDate(message.timestamp)}
                        </ChatModalMessageTime>
                        {/* <ReportButton onClick={() => reportMessage(message)}>
                          Zgłoś
                        </ReportButton> */}
                      </ChatModalMessageTimeAndnameContainer>
                    )}

                    <ChatModalMessage specialMessage={message.author_id == -1}>
                      {message.message}
                    </ChatModalMessage>
                  </ChatModalMessageRow>
                </ScrollContainer>
              ) : null
            )
          ) : (
            <ChatModalMessageRow>Nie ma żadnych wiadomości</ChatModalMessageRow>
          )}
        </ChatModalContent>

        <ActionRow>
          <ReportInformationRow>
            kliknij na post żeby zgłosić nadużycie
          </ReportInformationRow>
          <ActionRowInstruction>
            {user && user.is_banned_on_chat
              ? 'Zbanowano na chacie'
              : 'Wpisz tekst'}
          </ActionRowInstruction>
          {user && !user.is_banned_on_chat && (
            <SendButton
              isSending={sendingMessage}
              onClick={!sendingMessage && addMessage}
            >
              <SendButtonImage />
            </SendButton>
          )}
          <Input
            disabled={user && user.is_banned_on_chat && sendingMessage}
            onChange={(e) => !sendingMessage && setMessage(e)}
            value={chatMessageToSend}
            onKeyDown={(e) => !sendingMessage && addmessageOnEnter(e)}
            type="text"
          ></Input>

          {sendingMessage && (
            <SendingMessageLoader
              type="ThreeDots"
              color="#fe0d9f"
              height={isMobile ? 45 : 80}
              width={isMobile ? 45 : 80}
            />
          )}
        </ActionRow>
      </DropdownModalContainer>
    </Modal>
  )
}
export default ChatModal
